<template>
  <div>
    <div v-for="(item, idx) in items" :key="idx">
      <ShipmentPrototypeItem
        :visible="item.flag"
        :expanded="false"
        :collapsible="false"
        :key="item.id"
        :id="item.id"
        @delete="removeItem"
        @toggleHazard="toggleHazardous(idx)"
      >
        <template v-slot:title>
          <b-input-group>
            <b-form-datepicker
              reset-button
              v-model="item.paidDate"
              class="normalize text-center"
            ></b-form-datepicker>
            <b-form-input
              aria-label="Amount"
              placeholder="Amount"
              class="col-3 text-center"
              type="number"
              step="0.01"
              min="0"
              v-model.number="item.amount"
              number
            ></b-form-input>
          </b-input-group>
        </template>
      </ShipmentPrototypeItem>
    </div>
    <hr class="my-0">
    <b-button
      variant="outline-dark"
      class="mt-3 text-xs"
      @click="addNewItem()"
    >
      Add Payment
    </b-button>
  </div>
</template>

<script>
import ShipmentPrototypeItem from './ShipmentPrototypeItem.vue';

export default {
  name: 'ShipmentPrototypePaymentList',
  props: ['items'],
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
    toggleHazardous(idx) {
      this.$emit('toggleHazard', idx);
    },
  },
  components: { ShipmentPrototypeItem },
};
</script>

<style scoped>

</style>
